<template>
  <div class="home-demand-body">
    <div>
      <div class="home-title">
        <p>场景需求</p>
      </div>
      <div class="home-demand-content">
        <div class="home-demand-list-box">
          <div class="home-demand-list-title">
            <p>需求清单</p>
            <span @click="$router.push(`/homeScenes`)">查看更多></span>
          </div>
          <div class="home-demand-table">
            <a-table
              :columns="demandHead"
              :data-source="demandData"
              :pagination="false"
              :customRow="customRowBtn"
              row-key="id"
            >
              <div slot="status" slot-scope="text" class="home-demand-status">
                <i v-if="text === 'SYS0201'" class="yfb"></i>
                <i v-else-if="text === 'SYS0203'" class="gsz"></i>
                <i v-else></i>
                {{ SCENE_STATUS_MAP[text] }}
              </div>
              <span
                slot="publishTime"
                slot-scope="text"
                class="home-demand-status"
              >
                {{ text | moment("YYYY-MM-DD") }}
              </span>
              <span
                slot="applyDueDate"
                slot-scope="text"
                class="home-demand-status"
              >
                {{ text | lastTime }}
              </span>
            </a-table>
          </div>
        </div>
        <div class="home-demand-list-box">
          <div class="home-demand-list-title">
            <p>最新揭榜</p>
            <!-- <span>查看更多></span> -->
          </div>
          <div class="home-demand-table">
            <a-table
              row-key="id"
              :columns="newColumns"
              :data-source="newData"
              :pagination="false"
              :customRow="customRowBtn"
            >
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sceneList } from "@/api/scene";
import { SCENE_STATUS_MAP } from "@/store/constant";

const demandHead = [
  {
    title: "榜单名称",
    dataIndex: "sceneName",
    ellipsis: true,
    width: 200,
  },
  {
    title: "状态",
    dataIndex: "statusName",
    // scopedSlots: { customRender: "status" },
  },
  {
    title: "发榜时间",
    dataIndex: "publishTime",
    scopedSlots: { customRender: "publishTime" },
  },
  {
    title: "截止时间",
    dataIndex: "applyDueDate",
    scopedSlots: { customRender: "applyDueDate" },
  },
];
const newColumns = [
  {
    title: "榜单名称",
    dataIndex: "sceneName",
    ellipsis: true,
    width: 180,
  },
  {
    title: "揭榜单位",
    dataIndex: "chooseBidderName",
    ellipsis: true,
    width: 180,
  },
  {
    title: "揭榜时间",
    dataIndex: "chooseBidTime",
  },
];
export default {
  data() {
    return {
      demandHead,
      demandData: [],
      newColumns,
      newData: [],
      SCENE_STATUS_MAP,
    };
  },
  methods: {
    loadData() {
      sceneList({ current: 1, size: 5 }, {}).then((res) => {
        this.demandData = res.data.records;
      });
      sceneList({ current: 1, size: 5 }, { status: "SYS0203" }).then((res) => {
        this.newData = res.data.records;
      });
    },
    customRowBtn(record) {
      let _this = this;
      return {
        on: {
          click: () => {
            _this.$router.push({
              path: "/homeScenes/detail",
              query: { id: record.id },
            });
          },
        },
      };
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
.home-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  > p {
    font-size: 24px;
    line-height: 24px;
    padding-left: 12px;
    border-left: 4px solid #1abc9c;
    font-weight: 400;
  }
  > span {
    line-height: 14px;
    color: #8c8c8c;
    cursor: pointer;
  }
}
.home-demand-body {
  padding: 40px 0 56px;
  > div {
    width: 1200px;
    margin: 0 auto;
    .home-demand-content {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      .home-demand-list-box {
        width: 588px;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        .home-demand-list-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 56px;
          border-bottom: 1px solid #f0f0f0;
          padding: 0 16px;
          > p {
            font-size: 16px;
            font-weight: bold;
          }
          > span {
            color: #8c8c8c;
            cursor: pointer;
          }
        }
        .home-demand-table {
          padding: 16px 24px;
        }
      }
    }
  }
}
.home-demand-state {
  display: flex;
  align-items: center;
  > i {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #bfbfbf;
    margin-right: 6px;
    &.yfb {
      background: #1890ff;
    }
    &.gsz {
      background: #faad14;
    }
  }
}
</style>
<style>
.home-demand-table .ant-table-thead > tr > th {
  font-weight: bold;
}
.home-demand-table .ant-table-tbody > tr > td {
  color: #262626;
}
</style>
